(function(){
  var nav = document.getElementById('svFilterNav');
  var grid = document.getElementById('svProductGrid');
  if (!nav || !grid) return;
  var btns = nav.querySelectorAll('.sv-filter-btn');
  var cards = grid.querySelectorAll('.sv-product-card');
  btns.forEach(function(btn){
    btn.addEventListener('click', function(){
      var filter = this.getAttribute('data-filter');
      btns.forEach(function(b){
        b.classList.remove('is-active');
        b.style.color = 'rgba(255,255,255,.4)';
        b.style.borderBottomColor = 'transparent';
      });
      this.classList.add('is-active');
      this.style.color = 'var(--sv-white)';
      this.style.borderBottomColor = 'var(--sv-green)';
      cards.forEach(function(card){
        if (filter === 'all' || card.getAttribute('data-category') === filter) {
          card.style.display = '';
        } else {
          card.style.display = 'none';
        }
      });
    });
  });
})();